import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { getEvents } from '../Service/Api';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import '../../node_modules/slick-carousel/slick/slick.css';
import '../Assets/css/slick.css'
import '../Assets/css/slick-theme.css'
import LazyLoad from 'react-lazyload';
// import '../../node_modules/slick-carousel/slick/slick-theme.css';

const Events = () => {
    const [data, setData] = useState([]);
    
    useEffect(() => {
      const getData = async () => {
        const datas = await getEvents();
        setData(datas);
      };
      getData();
    }, []);
    
    const settings = {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]
    };

    return (
        <Slider {...settings}>
            {data?.length > 0 ? (
                data.map((item, index) => (
                    <div className="item" key={index}>
                        <div className='evt-blk'>
                            <div className="evt-img">
                            <LazyLoad>  {item.images.length > 0 ? 
                                    (<img className='img-fluid' src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images}`} alt="St Mary School, Mirzapur" />) : 
                                    (<img className='img-fluid' src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/event.jpg" alt="St Mary School, Mirzapur" />)}</LazyLoad>
                                <div className="evt-title"><h3>{item.title}</h3></div> 
                            </div>
                            <div className='evt-content'> 
                                <p>
                                    <LazyLoad><img className='img-fluid' src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/calender.png" alt="St Mary School, Mirzapur" /></LazyLoad>
                                    {new Date(item.date).toLocaleString('en-US', { month: 'short' })}  
                                    {new Date(item.date).getDate()}, {new Date(item.date).getFullYear()} 
                                    <span><LazyLoad><img className='img-fluid' src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/clock.png" alt="St Mary School, Mirzapur" /></LazyLoad> {item.time}</span>
                                </p>
                                <p>
                                    <LazyLoad>
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/location.png" className='img-fluid' alt="St Mary School, Mirzapur" /> </LazyLoad> {item.venue}</p>
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <div className="item">
                    <div className='evt-blk'>
                        <div className="evt-img">
                            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/event.jpg" alt="St Mary School, Mirzapur"/></LazyLoad>
                            <div className="evt-title"><h3>Event Title</h3></div> 
                        </div>
                        <div className='evt-content'> 
                            <p> <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/calender.png" alt="St Mary School, Mirzapur" /> </LazyLoad> DD. MM.YYYY 
                                <span> <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/clock.png" alt="St Mary School, Mirzapur"></img> </LazyLoad> HH:MM</span>
                            </p>
                            <p> <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/location.png" alt="St Mary School, Mirzapur"/> </LazyLoad> School</p>
                        </div>
                    </div>
                </div>
            )}
        </Slider>
    );
};

export default Events;
